import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState
} from 'react';
import { connect } from 'react-redux';
import MaterialTable from '@material-table/core';
import flowRight from 'lodash.flowright';
import { injectIntl } from 'react-intl';

import tableColumns from './tableColumns';
import { mapTableOptions } from '../../../consts/tableOptions';
import useTableLocalization from '../../../utils/useTableLocalization';
import {
  getTablePageSize,
  saveTablePageSize
} from '../../../utils/localstorageUtils';
import fetchChangeLog from '../actions/fetchChangeLog';
import CustomTableTitle from '../../../partials/CustomTableTitle';
import FilterButton from '../../../partials/tableCustomButtons/FilterButton';
import RefreshButton from '../../../partials/tableCustomButtons/RefreshButton';

const ChangeLogTable = ({ intl, isLoading, selectedClient }) => {
  const [filtering, setFiltering] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const { localization, language } = useTableLocalization();
  const tableRef = useRef();

  const pageSize = getTablePageSize({ tableName: 'ChangeLog' });

  const onChangeRowsPerPage = useCallback(size => {
    saveTablePageSize({ tableName: 'ChangeLog', pageSize: size });
  }, []);

  const tableDefaultColumns = useMemo(() => {
    return tableColumns({ selectedClient });
  }, [selectedClient, language]);

  const tableOptions = useMemo(() => {
    return {
      ...mapTableOptions({ exportData: false }),
      pageSize,
      search: false,
      columnsButton: false,
      pageSize,
      filtering
    };
  }, [filtering, pageSize]);

  useEffect(() => {
    tableRef.current.onQueryChange();
    // eslint-disable-next-line
  }, [selectedClient]);

  useEffect(() => {
    if (refresh) {
      tableRef.current.onQueryChange();
      setRefresh(false);
    }
    // eslint-disable-next-line
  }, [refresh]);

  const fetchData = useCallback(
    query => {
      return fetchChangeLog({ query, clientId: selectedClient.value });

      // eslint-disable-next-line
    },
    [selectedClient]
  );

  const actions = useMemo(
    () => {
      let buttons = [
        {
          icon: () => <FilterButton />,
          onClick: () => {
            setFiltering(!filtering);
          },
          isFreeAction: true,
          tooltip: intl.formatMessage({ id: 'BUTTON.FILTER' })
        },
        {
          icon: () => <RefreshButton tableHeader={true} />,
          onClick: () => setRefresh(true),
          isFreeAction: true
        }
      ];

      return buttons;
    },
    // eslint-disable-next-line
    [filtering]
  );

  return (
    <MaterialTable
      title={
        <CustomTableTitle
          text="MENU.CHANGELOG"
          icon={<i className="fas fa-history"></i>}
        />
      }
      columns={tableDefaultColumns}
      data={fetchData}
      options={tableOptions}
      localization={localization}
      tableRef={tableRef}
      isLoading={isLoading}
      actions={actions}
      onRowsPerPageChange={onChangeRowsPerPage}
    />
  );
};

const mapStatesToProps = ({ loader }) => {
  return {
    isLoading: loader.isSpinVisible
  };
};

export default flowRight(injectIntl, connect(mapStatesToProps))(ChangeLogTable);
